import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { arrivalSteps, distances } from '../data/site';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function LocationSection() {
  return <section id="location" className="w-full bg-sand-light py-24 sm:py-28 lg:py-36" data-id="element-209" data-mp="1i7ki0e2nideq">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12" data-id="element-210" data-mp="1dehlbx2kunub">
        <Reveal className="max-w-2xl" data-id="element-211" data-mp="1s3nuacr7vsfe">
          <SectionLabel data-id="element-212" data-mp="1s2m5l5ha37f7">Location</SectionLabel>
          <h2 className="mt-6 font-serif text-[clamp(2rem,4.5vw,3.5rem)] font-light leading-[1.08] text-forest-deep" data-id="element-213" data-mp="1n5cku34u3jxp">
            Perfectly located in Taveuni
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 lg:mt-20 lg:grid-cols-5" data-id="element-214" data-mp="1x3a74l34v6no">
          <Reveal className="lg:col-span-3" data-id="element-215" data-mp="1x41rt0v6zjz6">
            <div className="relative h-[320px] overflow-hidden rounded-[1.75rem] bg-ocean/90 shadow-soft sm:h-[420px] lg:h-full lg:min-h-[520px]" data-id="element-216" data-mp="6qktzunc6kqi">
              <div className="absolute inset-0 opacity-40" style={{
              backgroundImage: 'radial-gradient(circle at 30% 25%, rgba(36,69,58,0.9) 0%, transparent 42%), radial-gradient(circle at 72% 68%, rgba(36,69,58,0.75) 0%, transparent 38%), repeating-linear-gradient(90deg, rgba(250,246,239,0.09) 0 1px, transparent 1px 64px), repeating-linear-gradient(0deg, rgba(250,246,239,0.09) 0 1px, transparent 1px 64px)'
            }} aria-hidden="true" data-id="element-217" data-mp="2qttv0bx6s9b" />
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center" data-id="element-218" data-mp="3afworzghfe66">
                <span className="relative mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gold text-forest-deep shadow-lift" data-id="element-219" data-mp="3ferg5psimb1w">
                  <MapPin className="h-6 w-6" aria-hidden="true" data-id="element-220" data-mp="3kdku1jbps42l" />
                  <span className="absolute inset-0 animate-ping rounded-full bg-gold/40" data-id="element-221" data-mp="1l21gssjdo9n4" />
                </span>
                <p className="mt-5 font-serif text-2xl text-ivory" data-id="element-222" data-mp="1q14fzwcofln6">The Homestay</p>
                <p className="mt-1 text-[11px] uppercase tracking-wider-xl text-ivory/60" data-id="element-223" data-mp="1hyvhw2u6cuso">
                  Taveuni, Fiji
                </p>
              </div>
              <p className="absolute bottom-5 left-6 text-[10px] uppercase tracking-wider-xl text-ivory/45" data-id="element-224" data-mp="1rxtbvladdgj2">
                Interactive map placeholder
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-2" data-id="element-225" data-mp="20yhnk9caj4ss">
            <div className="h-full rounded-[1.75rem] bg-ivory p-8 shadow-soft sm:p-10" data-id="element-226" data-mp="20wy6whmq2rqh">
              <h3 className="text-[12px] font-semibold uppercase tracking-[0.16em] text-forest-deep" data-id="element-227" data-mp="1ww4izo9a5cxl">
                Getting around
              </h3>
              <ul className="mt-7 space-y-4" data-id="element-228" data-mp="25phmtl8vtyyg">
                {distances.map(item => <li key={item.label} className="flex items-baseline justify-between gap-4 border-b border-sand-dark/40 pb-4 last:border-0" data-id="element-229" data-mp="2kmi5z0d0cllb">
                    <span className="text-[15px] text-forest-deep/75" data-id="element-230" data-mp="2z97chm5ofz17">
                      {item.label}
                    </span>
                    <span className="font-serif text-lg text-ocean" data-id="element-231" data-mp="339raery2r6oe">
                      {item.time}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-10 rounded-2xl bg-sand-light p-6" data-id="element-232" data-mp="2u9ba1rcmofnr">
                <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-forest-deep" data-id="element-233" data-mp="2fl82wemumxxd">
                  Address
                </p>
                <p className="mt-2 text-[15px] leading-relaxed text-forest-deep/60" data-id="element-234" data-mp="2kcq493ssb0iv">
                  Exact address shared after booking. Placeholder — full property
                  address to be confirmed.
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-20" data-id="element-235" data-mp="1wnnch34frran">
          <Reveal data-id="element-236" data-mp="1wof7ocu4fn0e">
            <h3 className="font-serif text-[clamp(1.6rem,3vw,2.5rem)] font-light text-forest-deep" data-id="element-237" data-mp="21lfdqnqz0pri">
              How to get here
            </h3>
          </Reveal>

          <ol className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-238" data-mp="34vjgphi6fu30">
            {arrivalSteps.map((step, i) => <Reveal as="li" key={step.step} delay={i * 0.08} data-id="element-239" data-mp="2zzm1xfmkavsc" data-mpi={i}>
                <div className="h-full rounded-[1.5rem] border border-sand-dark/50 bg-ivory p-7 transition-all duration-500 ease-calm hover:-translate-y-1 hover:shadow-soft" data-id="element-240" data-mp="2v4ylm41pp7ou">
                  <span className="font-serif text-[13px] tracking-[0.2em] text-gold" data-id="element-241" data-mp="2l8lqr2ufknsi">
                    {step.step}
                  </span>
                  <h4 className="mt-4 text-[15px] font-semibold text-forest-deep" data-id="element-242" data-mp="2h8uvaltyljhn">
                    {step.title}
                  </h4>
                  <p className="mt-2.5 text-[14px] leading-relaxed text-forest-deep/60" data-id="element-243" data-mp="2793zmgtnwyfz">
                    {step.description}
                  </p>
                </div>
              </Reveal>)}
          </ol>

          <Reveal delay={0.1} data-id="element-244" data-mp="5i92nlnpyt7o">
            <a href="#book" className="mt-10 inline-flex items-center gap-3 rounded-full bg-ocean px-8 py-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory transition-all duration-300 ease-calm hover:-translate-y-0.5 hover:bg-ocean-deep hover:shadow-lift" data-id="element-245" data-mp="5i0qxx3c1ty2">
              <Navigation className="h-4 w-4" aria-hidden="true" data-id="element-246" data-mp="msw6h89bl1j0" />
              Arrange your transfer
            </a>
          </Reveal>
        </div>
      </div>
    </section>;
}